import { render, staticRenderFns } from "./WebsiteLogo.vue?vue&type=template&id=1c97b3ca&scoped=true&"
import script from "./WebsiteLogo.vue?vue&type=script&lang=js&"
export * from "./WebsiteLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97b3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c97b3ca')) {
      api.createRecord('1c97b3ca', component.options)
    } else {
      api.reload('1c97b3ca', component.options)
    }
    module.hot.accept("./WebsiteLogo.vue?vue&type=template&id=1c97b3ca&scoped=true&", function () {
      api.rerender('1c97b3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteLogo.vue"
export default component.exports